import { Box, Button, Stack, styled, Typography } from "@mui/material";
import React from "react";
import { conradEnergyFreshGreenColour } from "../../../shared/theme/themeBrand";
import { DataGrid, GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { common } from "@mui/material/colors";
import { IPNPlanSubmission } from "../../../shared/types/dispatch/IFailedPnMetrics";
import { FormatDateToString } from "../../../shared/helpers/dateTimeHelper";

const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
    border: "none",
    "& .MuiDataGrid-columnSeparator": {
        display: "none",
    },
    "& .data-grid-text-success": {
        color: theme.palette.success.main,
    },
    "& .data-grid-text-error": {
        color: theme.palette.error.main,
    },
    ".MuiDataGrid-columnHeaders": {
        background: common.black,

        "> div:first-of-type": {
            background: common.black,
            "> .MuiDataGrid-columnHeader": {
                height: "auto",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
                whiteSpace: "normal !important",
                wordWrap: "normal !important",
                textAlign: "center",
            },
            "& .MuiDataGrid-sortIcon": {
                width: 0,
                height: 0,
                borderLeft: "6px solid transparent",
                borderRight: "6px solid transparent",
                borderBottom: "10px solid currentColor",
                marginLeft: 4,
                opacity: 1,
                visibility: "visible",
            },
        },
    },
    "& .MuiDataGrid-columnHeaderTitle": {
        fontSize: "17px",
        fontWeight: "bold",
    },
    "& .invisible-col": {
        color: "transparent",
        pointerEvents: "none",
        userSelect: "none",
        textIndent: "-9999px",
        overflow: "hidden",
    },
    "& .invisible-col-header": {
        opacity: 0,
        userSelect: "none",
        textIndent: "-9999px", 
        overflow: "hidden",
    },
}));

export const FailedPnOutstandingTable: React.FC<IFailedPnOutstandingTableProps> = ({ data, onClickResubmit }) => {

    const columns: GridColDef<IPNPlanSubmission>[] = [
        {
            field: 'unitID',
            headerName: 'Site',
            disableColumnMenu: true,
            width: 150,
            resizable: false,
            align: "left",
            headerAlign: "left",
            valueGetter: (params) => `${params.row.unitID}`,
        },
        {
            field: 'pnBegins',
            headerName: "PN Begins",
            disableColumnMenu: true,
            width: 150,
            resizable: false,
            align: "left",
            headerAlign: "left",
            valueFormatter: (params) => FormatDateToString(params.value, "DD.MM.YYYY HH:mm")
        },
        {
            field: 'pnEnds',
            headerName: "PN Ends",
            disableColumnMenu: true,
            width: 150,
            resizable: false,
            align: "left",
            headerAlign: "left",
            valueFormatter: (params) => FormatDateToString(params.value, "DD.MM.YYYY HH:mm")
        },
        {
            field: 'lastSubmitted',
            headerName: "Last Submitted",
            disableColumnMenu: true,
            width: 200,
            resizable: false,
            align: "left",
            headerAlign: "left",
            valueFormatter: (params) => FormatDateToString(params.value, "DD.MM.YYYY HH:mm")
        },
        {
            field: 'lastErrorCode',
            headerName: "Last Error Code",
            disableColumnMenu: true,
            width: 200,
            resizable: false,
            align: "left",
            headerAlign: "left"
        },
        {
            field: 'submissionAttempts',
            headerName: "Submission Attempts",
            disableColumnMenu: true,
            width: 250,
            resizable: false,
            align: "center",
            headerAlign: "left"
        },
        {
            field: 'buttons',
            headerName: "Resubmit",
            disableColumnMenu: true,
            sortable: false,
            editable: false,
            flex: 1,
            minWidth: 200,
            align: "left",
            renderCell: (params: GridRenderCellParams<IPNPlanSubmission>) => (
                <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
                    <Stack direction="row" spacing={1}>
                        <Button
                            style={{ color: "white"} }
                                onClick={() => onClickResubmit(params.row)}
                            >
                                Resubmit
                        </Button>
                    </Stack>
                </Box>
            ),
        },
    ];

    return (
        <Box height="100%">
            <Stack direction="column" >
                <Typography
                    sx={{ fontWeight: "bold", lineHeight: 2, color: conradEnergyFreshGreenColour.main }} height="100%" variant="h5" noWrap>
                    Outstanding
                </Typography>

                <Box sx={{ width: '100%', height: 300, overflow: "auto" }}>
                    <StyledDataGrid
                        getRowId={(row) => `${row.id}`}
                        autosizeOnMount
                        autosizeOptions={{
                            includeHeaders: true,
                            expand: true,
                            columns: ["unitID", "lastErrorCode"]
                        }}
                        rows={data}
                        // @ts-expect-error
                        columns={columns}
                        disableSelectionOnClick
                        autoHeight={false}
                    >
                    </StyledDataGrid>
                </Box>
            </Stack>
        </Box>
    );
}


export interface IFailedPnOutstandingTableProps {
    data: IPNPlanSubmission[];
    onClickResubmit: (pnPlan: IPNPlanSubmission) => void;
}
